import { Conversation } from "@/types/conversation/conversation";

export interface ExtractedCustomer {
  name: string | null;
  email: string | null;
  phone: string | null;
}

/** Who the genie was talking to, as picked out of this one conversation by its analysis. */
export function extractCustomer(conversation: Conversation): ExtractedCustomer {
  const analysis = asRecord(conversation?.details?.analysis_result);
  const metadata = asRecord(conversation?.metadata);
  const leadInfo = asRecord(conversation?.details?.lead_info);

  const customerData =
    asRecord(analysis?.customer_data) ?? asRecord(metadata?.customer_data) ?? {};

  return {
    name: firstText(
      customerData.name,
      customerData.full_name,
      customerData.customer_name,
      leadInfo?.name,
      leadInfo?.full_name,
      leadInfo?.contact_name,
    ),
    email: firstText(
      customerData.email,
      customerData.customer_email,
      leadInfo?.email,
      leadInfo?.email_address,
    ),
    phone: firstText(
      customerData.phone,
      customerData.phone_number,
      leadInfo?.phone,
      leadInfo?.phone_number,
    ),
  };
}

function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  return value as Record<string, unknown>;
}

/** First non-blank string among the candidates, trimmed. */
function firstText(...values: unknown[]): string | null {
  for (const value of values) {
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return null;
}
